<section
  class="quantifiers"
  [formGroup]="childForm"
  *ngIf="
    currentDataFields &&
    currentDataFields.length > 0 &&
    chartType &&
    chartType != 'Table' &&
    chartType != 'List'
  "
>
  <span class="sectionHeader">CALCULATION METHOD* </span>

  <div class="fieldArea">
    <div
      class="group-list"
      *ngIf="chartType && chartType != 'Table' && chartType != 'List'"
    >
      <div>
        <div class="reportField-box">
          <div class="canvasFields">
            <div class="right">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-select
                  formControlName="calculationMethod"
                  placeholder="Choose a calculation"
                  floatPlaceholder="never"
                  (selectionChange)="buildAggregateData($event)"
                >
                  <mat-option
                    *ngFor="let item of calculationOptions"
                    [value]="item.value"
                  >
                    {{ item.text }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="far-right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
